import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Button, Paragraph, Popup } from '@quickmd-llc/design-system'
import { ADMIN_EVENT_NAMES, tracking } from '@/lib/segment/tracking'
import { PATIENT_CHARTS_PAGE_ROUTE } from '@/utils/constants'
import { useMergeAccounts } from './context/useMergeAccounts'

export function CancelButton() {
  const navigate = useNavigate()
  const { selectedPatients } = useMergeAccounts()
  const [visible, setIsVisible] = useState<boolean>(false)

  function navigateToPatientCharts() {
    navigate(PATIENT_CHARTS_PAGE_ROUTE)
  }

  function handleClickCancel() {
    tracking.trackEvent(ADMIN_EVENT_NAMES.MERGE_ACCOUNTS_CANCEL)

    if (selectedPatients.length > 0) {
      setIsVisible(true)
      return
    }

    navigateToPatientCharts()
  }

  function handleClickConfirm() {
    tracking.trackEvent(ADMIN_EVENT_NAMES.MERGE_ACCOUNTS_CANCEL_CONTINUE)

    navigateToPatientCharts()
  }

  function handleClickDismiss() {
    tracking.trackEvent(ADMIN_EVENT_NAMES.MERGE_ACCOUNTS_CANCEL_CANCEL)

    setIsVisible(false)
  }

  return (
    <>
      {visible ?
        <Popup
          isOpen
          header='Unsaved changes'
          body={<Paragraph>Are you sure you want to exit this screen? All progress will be lost.</Paragraph>}
          footer={
            <div className='flex justify-end gap-sp-1'>
              <Button onClick={() => handleClickDismiss()} priority='secondary'>
                Cancel
              </Button>

              <Button onClick={() => handleClickConfirm()}>Continue</Button>
            </div>
          }
          showCloseIcon
          onClose={() => handleClickDismiss()}
        />
      : null}

      <Button priority='secondary' onClick={() => handleClickCancel()} data-testid='pw_merge-cancel'>
        Cancel
      </Button>
    </>
  )
}
